import { UpdateMaterialRequest } from "api/models/request/product/material";
import { ObjectSchemaType } from "commons/ultilities/dynamic-form/hooks/use-form";
import { InputType } from "commons/ultilities/dynamic-form/models/control";
import { numberNanable } from "commons/ultilities/validation";
import { MaterialFixDecimalConstants } from "mobx-stores/_models/products/const";
import { string } from "yup";
export const getMaterialFormSchema =
  (): ObjectSchemaType<UpdateMaterialRequest> => ({
    paperType: {
      label: "Loại giấy",
      type: InputType.text,
      gridSize: 4,
      validattionYupSchema: string().required().max(255),
    },
    paperBrand: {
      label: "Hiệu giấy",
      type: InputType.text,
      gridSize: 4,
      validattionYupSchema: string().max(255),
    },
    standard: {
      label: "Đặt chuẩn",
      type: InputType.text,
      gridSize: 4,
      validattionYupSchema: string().max(255),
    },
    gsmStandard: {
      label: "GSM chuẩn (gram)",
      type: InputType.number,
      gridSize: 3,
      validattionYupSchema: numberNanable().required(),
      metaData: {
        fixDecimalScale: MaterialFixDecimalConstants.GSM_STANDARD,
      },
    },
    gsmUpperFactorPercent: {
      type: InputType.number,
      label: "H/S trên (+ %)",
      gridSize: 1.5,
      validattionYupSchema: numberNanable(),
      metaData: {
        fixDecimalScale: MaterialFixDecimalConstants.GSM_UPPER_FACTOR_PERCENT,
      },
    },
    gsmUpper: {
      label: "GSM trên (gram)",
      type: InputType.number,
      gridSize: 3,
      validattionYupSchema: numberNanable(),
      disabled: true,
      metaData: {
        fixDecimalScale: MaterialFixDecimalConstants.GSM_UPPER,
      },
    },
    gsmLowerFactorPercent: {
      type: InputType.number,
      label: "H/S dưới (- %)",
      validattionYupSchema: numberNanable(),
      gridSize: 1.5,
      metaData: {
        fixDecimalScale: MaterialFixDecimalConstants.GSM_LOWER_FACTOR_PERCENT,
      },
    },
    gsmLower: {
      label: "GSM dưới (gram)",
      type: InputType.number,
      gridSize: 3,
      validattionYupSchema: numberNanable(),
      disabled: true,
      metaData: {
        fixDecimalScale: MaterialFixDecimalConstants.GSM_LOWER,
      },
    },
    thicknessStandard: {
      label: "Độ dầy chuẩn (mm)",
      type: InputType.number,
      gridSize: 3,
      validattionYupSchema: numberNanable().required(),
      metaData: {
        fixDecimalScale: MaterialFixDecimalConstants.THICKNESS_STANDARD,
      },
    },
    thicknessUpperFactorPercent: {
      type: InputType.number,
      label: "H/S trên (+ %)",
      gridSize: 1.5,
      validattionYupSchema: numberNanable(),
      metaData: {
        fixDecimalScale:
          MaterialFixDecimalConstants.THICKNESS_UPPER_FACTOR_PERCENT,
      },
    },
    thicknessUpper: {
      label: "Độ dầy trên (mm)",
      type: InputType.number,
      gridSize: 3,
      validattionYupSchema: numberNanable(),
      disabled: true,
      metaData: {
        fixDecimalScale: MaterialFixDecimalConstants.THICKNESS_UPPER,
      },
    },
    thicknessLowerFactorPercent: {
      type: InputType.number,
      label: "H/S dưới (- %)",
      gridSize: 1.5,
      validattionYupSchema: numberNanable(),
      metaData: {
        fixDecimalScale:
          MaterialFixDecimalConstants.THICKNESS_LOWER_FACTOR_PERCENT,
      },
    },
    thicknessLower: {
      label: "Độ dầy dưới (mm)",
      type: InputType.number,
      gridSize: 3,
      validattionYupSchema: numberNanable(),
      disabled: true,
      metaData: {
        fixDecimalScale: MaterialFixDecimalConstants.THICKNESS_LOWER,
      },
    },
    whitenessStandard: {
      label: "Độ trắng chuẩn (%)",
      type: InputType.number,
      gridSize: 3,
      validattionYupSchema: numberNanable().required(),
      metaData: {
        fixDecimalScale: MaterialFixDecimalConstants.WHITENESS_STANDARD,
      },
    },
    whitenessUpperFactorPercent: {
      type: InputType.number,
      label: "H/S trên (+ %)",
      gridSize: 1.5,
      validattionYupSchema: numberNanable(),
      metaData: {
        fixDecimalScale:
          MaterialFixDecimalConstants.WHITENESS_UPPER_FACTOR_PERCENT,
      },
    },
    whitenessUpper: {
      label: "Độ trắng trên (%)",
      type: InputType.number,
      disabled: true,
      gridSize: 3,
      validattionYupSchema: numberNanable(),
      metaData: {
        fixDecimalScale: MaterialFixDecimalConstants.WHITENESS_UPPER,
      },
    },
    whitenessLowerFactorPercent: {
      type: InputType.number,
      label: "H/S dưới (- %)",
      gridSize: 1.5,
      validattionYupSchema: numberNanable(),
      metaData: {
        fixDecimalScale:
          MaterialFixDecimalConstants.WHITENESS_LOWER_FACTOR_PERCENT,
      },
    },
    whitenessLower: {
      label: "Độ trắng dưới (%)",
      type: InputType.number,
      gridSize: 3,
      disabled: true,
      validattionYupSchema: numberNanable(),
      metaData: {
        fixDecimalScale: MaterialFixDecimalConstants.WHITENESS_LOWER,
      },
    },
  });
